// src/components/SafeAreaShell.tsx
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function SafeAreaShell({ children }: Props) {
  return (
    <div
      className="min-h-screen"
      style={{
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
      }}
    >
      {children}
    </div>
  );
}
